var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgElizaShipHappy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 608.57 328.86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{stroke:#33347e;stroke-width:.76px;}.cls-1,.cls-2,.cls-3,.cls-4,.cls-5,.cls-6{fill:none;stroke-miterlimit:10;}.cls-2{stroke:#1b1464;}.cls-2,.cls-3{stroke-width:.54px;}.cls-3{stroke:#001c57;}.cls-7{fill:#f875a8;}.cls-8{fill:#fac67a;}.cls-9{fill:#031f54;}.cls-10{fill:#001c56;}.cls-11{fill:#001c57;}.cls-12{fill:#000e26;}.cls-13{fill:#ffc57a;}.cls-14{fill:#ffbc55;}.cls-15{fill:#7e6da8;}.cls-16{fill:#021e54;}.cls-17{fill:#c1bfe9;}.cls-18{fill:#33347e;}.cls-19{fill:#d4417d;}.cls-20{fill:#5667a0;}.cls-21{fill:#4e4593;}.cls-22{fill:#4f166b;}.cls-4{stroke:#afceff;stroke-width:.72px;}.cls-5{stroke-linecap:round;}.cls-5,.cls-6{stroke:#4f166b;stroke-width:.9px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M284.64,266.89h0c1.75,2.16,4.42,3.38,7.2,3.3l30.43-.87c1.18-.03,1.37-1.72,.22-2l-17.46-4.39c-4.04-1.02-5.92-5.67-3.73-9.21l1.04-1.67h0c-7.12-6.62-18.73-2.15-19.58,7.53l-.08,.89c-.2,2.31,.5,4.61,1.96,6.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M234.32,184.78c-2.14-20.06,39.87-40.98,93.83-46.74,53.96-5.75,99.43,5.85,101.57,25.9,5.67,53.18-33.47,100.95-87.43,106.71-53.96,5.75-102.29-32.69-107.96-85.87Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M214.46,152.17l8.12,19.47c1.01,2.41,4.54,2.04,5.01-.53l3.83-20.74c2.75-14.91,3.34-30.14,1.73-45.21l-.77-7.18-29.91,3.19,.77,7.18c1.61,15.08,5.39,29.84,11.22,43.83Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-18",
    cx: 218.11,
    cy: 103.33,
    rx: 18.15,
    ry: 6.84,
    transform: "translate(-9.73 23.7) rotate(-6.09)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 199,
    y: 85.24,
    width: 36.25,
    height: 18.15,
    transform: "translate(443.03 165.08) rotate(173.91)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-10",
    cx: 216.19,
    cy: 85.29,
    rx: 18.15,
    ry: 6.84,
    transform: "translate(-7.82 23.4) rotate(-6.09)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M234.23,83.37c.4,3.76-7.35,7.67-17.32,8.73-9.97,1.06-18.37-1.12-18.77-4.88-1.06-9.97,6.15-18.9,16.12-19.97,9.97-1.06,18.9,6.15,19.97,16.12Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M100.38,248.53l103.97-23.63c.33-.08,.67-.16,1.01-.25,64.36-15.85,131.78-14.6,195.36,4.1,.97,.29,1.95,.58,2.91,.87,20.87,6.27,40.72,15.52,59.03,27.33l14.38,9.28,30.61-8.14-38.89-24.78c-4.68-2.7-14.22-10.55-18.48-13.86-34.52-26.81-17.71-72.59,35.5-90.57l47.28-18.53-11.59-11.24-71.5,18.34c-27.56,6.2-78.5,15.41-78.5,15.41-44.25,6.67-93.9,2.97-127.89-18.81-.49-.31-10.46-8.27-10.46-8.27h0c-5.31,3.4-14.1,5.22-22,4.5l-5.16-.72,1.86,1.67c7.28,6.55,8.43,17.18,12.12,27.65,10.54,29.93-6.74,56.05-47.68,69.95l-76.58,23.22,4.69,16.51Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M86.14,287.51l9.91,23.77c1.23,2.95,5.54,2.49,6.12-.65l4.68-25.33c3.36-18.21,4.07-36.8,2.11-55.21l-.93-8.77-36.53,3.89,.93,8.77c1.96,18.41,6.58,36.44,13.7,53.53Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-18",
    cx: 90.61,
    cy: 227.88,
    rx: 22.16,
    ry: 8.36,
    transform: "translate(-23.65 10.89) rotate(-6.09)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 67.27,
    y: 205.78,
    width: 44.26,
    height: 22.16,
    transform: "translate(201.3 423.02) rotate(173.91)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-10",
    cx: 88.26,
    cy: 205.84,
    rx: 22.16,
    ry: 8.36,
    transform: "translate(-21.32 10.52) rotate(-6.09)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M110.29,203.49c.49,4.59-8.98,9.36-21.15,10.66-12.17,1.3-22.43-1.37-22.92-5.96-1.3-12.17,7.52-23.08,19.68-24.38,12.17-1.3,23.08,7.52,24.38,19.68Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M485.63,303.12l9.91,23.77c1.23,2.95,5.54,2.49,6.12-.65l4.68-25.33c3.36-18.21,4.07-36.8,2.11-55.21l-.93-8.77-36.53,3.89,.93,8.77c1.96,18.41,6.58,36.44,13.7,53.53Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-18",
    cx: 490.09,
    cy: 243.48,
    rx: 22.16,
    ry: 8.36,
    transform: "translate(-23.05 53.33) rotate(-6.09)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 466.76,
    y: 221.38,
    width: 44.26,
    height: 22.16,
    transform: "translate(999.67 411.79) rotate(173.91)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-10",
    cx: 487.74,
    cy: 221.44,
    rx: 22.16,
    ry: 8.36,
    transform: "translate(-20.73 52.95) rotate(-6.09)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M509.77,219.09c.49,4.59-8.98,9.36-21.15,10.66-12.17,1.3-22.43-1.37-22.92-5.96-1.3-12.17,7.52-23.08,19.68-24.38,12.17-1.3,23.08,7.52,24.38,19.68Z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 334.15,
    cy: 165.94,
    rx: 63.56,
    ry: 17.69,
    transform: "translate(-15.71 36.36) rotate(-6.09)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 216.31,
    cy: 84.59,
    rx: 74.64,
    ry: 20.99,
    transform: "translate(-7.75 23.41) rotate(-6.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M174.65,75.06c-17.17,5.01-27.91,11.14-27.32,16.68,.56,5.29,11.37,8.93,27.92,10.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M185.77,77.21c-17.68,2.7-33.26,9.98-33.38,14.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M257.1,93.56c17.17-5.01,27.91-11.14,27.32-16.68-.56-5.29-11.37-8.93-27.92-10.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M245.98,91.41c17.68-2.7,33.26-9.98,33.38-14.39"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M294.4,159.82l84.57-4.32,8.89-45.37c2.03-10.37-6.29-19.87-16.84-19.21l-77.3,4.83c-10.67,.67-17.76,11.34-14.23,21.43l14.91,42.65Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M251.32,118.83c.23,2.17-4.25,4.43-10.01,5.04-5.76,.61-10.61-.65-10.84-2.82-.61-5.76,3.56-10.92,9.31-11.54,5.76-.61,10.92,3.56,11.54,9.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M245.63,118.96c.1,.95-1.86,1.94-4.38,2.21-2.52,.27-4.65-.28-4.75-1.23-.27-2.52,1.56-4.78,4.08-5.05s4.78,1.56,5.05,4.08Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-15",
    cx: 319.41,
    cy: 118.42,
    rx: 7.05,
    ry: 17.2,
    transform: "translate(-7.25 215.06) rotate(-36.82)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-15",
    cx: 364.27,
    cy: 108.86,
    rx: 22.54,
    ry: 9.23,
    transform: "translate(93.5 375.74) rotate(-61.22)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M237.46,30.49c-.32-1.27-.81-2.48-1.33-3.67-.24-.56-1.1-2.39-1.7-2.25-.7,.17-.01,2.48,.08,2.77,1.05,3.06,.86,4.38,.82,5.58-.3-1.01-1.98-6.01-2.4-6.66-.22-.34-1.4-2.11-1.74-1.05-.08,.24,.05,.77,.38,1.84,.44,1.44,1.35,6.22,1.16,6.78-.78-1.02-1.59-4.81-2.42-5.79-.39-.46-1.52-2.73-2.36-1.89-.37,.37,.53,2.51,.8,3.03,.57,1.09,.89,3.85,1.25,5.2-.75-.65-2.7-5.66-3.5-6.23-.38-.27-1.06-.06-1.04,.76,0,.34,4.84,12.68,5.76,14.2,0,0,.55,1.05,1.3,2.28,.21,.34,.65,.71,.98,.93,2.6,1.71,5.98-.76,5.26-3.81-.05-.23-.12-.46-.21-.68-.54-1.45-.49-8.92-1.11-11.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M317.73,119.25c-16.68-.78-32.66-3.18-47.2-12.01-13.16-7.99-23.41-25.1-29.19-39.12-3.61-8.76-9.41-22.01-9.41-22.01l7.13-2.83s6.34,12.83,9.9,19.3c3.13,5.7,6.92,11.59,10.64,16.92-.34-.48-.67-.96-1.01-1.44,3.69,5.25,7.84,10.17,12.74,14.32-.45-.38-.91-.76-1.36-1.15,3.65,3.07,7.66,5.61,11.98,7.63-.56-.26-1.11-.51-1.67-.77,6.19,2.85,12.8,4.6,19.51,5.72-.61-.1-1.21-.2-1.82-.3,6.68,1.09,13.45,1.59,20.21,1.9,3.58,.17,6.93,3.32,6.64,7.09-.29,3.67-3.26,6.91-7.1,6.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M237.47,39.64c.85-2.78,1.71-5.56,2.56-8.34,.3-.98,.14-2.56-.87-2.38-.32,.05-.57,.3-.78,.55-1.69,1.99-2.37,4.62-3,7.15-.19,.78-.39,1.62-.1,2.37,.29,.75,1.27,1.27,1.91,.79"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M309.07,104.47h0c2.18,1.64,7.81,3.09,11.63,8.7,4.83,7.1,7.72,18.44,7.72,18.44,0,0,8.21-16.82-.91-26.04h0c-7.77-8.63-18.44-1.1-18.44-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M360.46,110.74c3.18,9.58,.73,18.82-4.57,32.22-1.71,4.32,35.5,18.99,35.5,18.99-9.36,18.54-35.44,23.72-35.44,23.72-12.27-1.67-22.28-14.47-25.94-22.57,0,0,1.51-5.04,2.61-7.57,0,0,1.41-11.06-5.51-17.85-10.03-9.84-7.18-16.14-5.96-20.95,4.45-17.54,14.82-22.31,27.54-17.13,0,0,8.63,1.61,11.78,11.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M333.39,129.77l.63-1.39c5.59-12.4,13.21-23.79,22.54-33.69h0c-12.16-4.64-25.88-2.43-35.97,5.79l-1.61,1.31,14.41,27.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M333.39,129.77l1.86-12.52c1.08-5.2,4.04-11.73,6.79-16.27,1.08-1.77,2.53-3.52,5.53-6.17h0c-8.05-2.16-14.04-1.38-21.16,3.6h0c.78,6.7,2.07,13.34,3.84,19.85l3.14,11.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M334.6,101.1c.6,2.75,3.74,.52,4.82-1.49,2.12-3.96,2.02-5.7,2.02-5.7h0c.41,1.26-5.9-11.05-5.9-11.05l-7.03,5.06h0c3.18,2.95,5.03,8.33,6.08,13.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M333.25,129.29h0c-.17,5.02,.74,6.59,3.41,14.41l.27,.49"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M342.98,148.33c1.31-.31,8.24-.48,12.91-5.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M331.65,149.46s1.28,.63,3.15,.26"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 338.87,
    cy: 148.51,
    rx: 4.02,
    ry: 4.15,
    transform: "translate(-28 100.59) rotate(-16.22)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M356.59,79.76c-1.05,5.27-8.42,9.69-15.34,7.88-5.35-1.4-9.47-4.16-11.01-8.35h0c4.72,1.41,9.77,1.25,14.39-.46l2.53-.94c2.1,5.42,8.26,3.08,9.43,1.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M309.21,61.78c-2.32,3.85-.04,9.43,3.42,10.93,1.31,.57,9.69,4.89,17.43-9.4,.77-1.41,1.65-4.5,.75-6.18-.42-.78-1.37-1.56-2.23-1.79-1.48-.39-2.42,.65-3.38,2.33,0,0-1.33,4.28-6.23,7.04-6.15,3.46-10.21-2.35-9.75-2.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M311.37,69.03c-2.3,1.76-4.78-.21-4.63-.61-1.42,4.4,9.86,20.13,29.9,13.7,8.56,2.85,19.19-.81,22.82-8.12,1.74-3.5,1.06-8.72,1.06-8.72-.09,.23-1.58,3.41-3.68,3.32-2.45-.11-5.02-.05-4.14-7.34,1-8.29-3.98-14.53-8.52-16.93-13.48-7.12-26.06-1.69-29.59,2.55-5.02,6.03-4.54,11.1-3.86,14,.3,1.27,.73,2.5,1.26,3.69,.99,2.24,2.39,2.14-.63,4.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M313.65,56.28c-2.82,5.56-2.84,14.56-3.02,15.99-1.23,10.07,4.57,21.04,5.41,21.92,0,0,7.64-.94,15.7-5.14,3.31-1.73,6.51-4.88,9.47-7.32,1.27,.77,2.96,1.11,4.3,.34,3.18-1.84,3.85-5.55,2.52-7.38-.5-.69-1.24-1.25-2.09-1.42-.17-.03-7.02,1.89-11.05-1.86-7.4-6.88-.07-19.41-13.23-16.56-.53,.12-1.45-.26-1.45-.26l-1.6-.45c-1.96-.56-4.05,.34-4.97,2.16Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "317.17 70.85 313.28 78.97 317.6 80.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M314.54,83.66c1.26,5.16,8.53,6.43,11.73,.26l-11.73-.26Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M358.23,62.71c.3,3.68-3.41,6.93-6.5,6.78-1.17-.06-8.9,.05-9.37-13.26-.05-1.32,.43-3.9,1.71-4.81,.59-.42,1.58-.65,2.29-.5,1.23,.26,1.54,1.36,1.63,2.94,0,0-.58,3.63,2.01,7.44,3.25,4.78,8.35,2,8.23,1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M323.63,63c-3.03,2.1-7.71,.52-9.12-2.23-.53-1.04-4.5-7.68,6.79-14.75,1.12-.7,3.59-1.58,5.02-.93,.66,.3,1.35,1.04,1.58,1.73,.39,1.19-.4,2.01-1.73,2.89,0,0-3.43,1.31-5.43,5.46-2.51,5.21,2.45,8.23,2.91,7.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M337.64,63.93c-4.85,4.6-14.96-1.78-15.97-6.78-.38-1.89-5.94-8.74,13.14-13.81,1.89-.5,5.82-.57,7.64,1.17,.85,.81,1.57,2.32,1.63,3.51,.12,2.05-1.35,2.91-3.61,3.57,0,0,1.1-3.5-3.38,1.9-5.62,6.76-.28,10.83,.54,10.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M316.75,86.96c2.1,1.51,5.16,1.55,7.54-.49-1.54-1.19-5.85-.99-7.54,.49Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-11",
    cx: 316.21,
    cy: 70.03,
    rx: 2.76,
    ry: 1.52,
    transform: "translate(230.2 382.27) rotate(-87.09)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-11",
    cx: 327.94,
    cy: 71.67,
    rx: 2.76,
    ry: 1.52,
    transform: "translate(204.2 383.71) rotate(-80.7)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M419.08,6.75c.05-1.31,.27-2.6,.53-3.87,.12-.6,.58-2.57,1.19-2.56,.72,.01,.54,2.42,.5,2.72-.38,3.21,.09,4.47,.37,5.63,.08-1.05,.67-6.3,.95-7.02,.15-.38,.93-2.35,1.48-1.39,.13,.22,.11,.77,.02,1.88-.13,1.51,0,6.37,.3,6.87,.55-1.16,.54-5.04,1.14-6.17,.28-.53,.91-2.99,1.9-2.34,.44,.29,.01,2.56-.15,3.13-.33,1.19-.05,3.95-.13,5.34,.6-.79,1.45-6.1,2.11-6.83,.32-.35,1.03-.28,1.18,.52,.06,.34-2.06,13.41-2.64,15.1,0,0-.32,1.14-.79,2.5-.13,.38-.49,.83-.76,1.11-2.18,2.22-6,.52-5.94-2.61,0-.24,.02-.47,.06-.71,.22-1.53-1.4-8.83-1.31-11.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M359.34,110.44c16.14-4.28,31.26-9.99,43.6-21.69,11.18-10.59,17.59-29.47,20.28-44.39,1.68-9.32,4.56-23.5,4.56-23.5l-7.56-1.26s-3.49,13.88-5.6,20.96c-1.86,6.23-4.32,12.79-6.84,18.79,.23-.54,.45-1.08,.68-1.62-2.5,5.91-5.52,11.59-9.43,16.68,.36-.47,.73-.94,1.09-1.41-2.92,3.77-6.31,7.1-10.1,9.99,.49-.37,.98-.74,1.47-1.1-5.45,4.09-11.54,7.19-17.87,9.7,.57-.22,1.14-.45,1.71-.67-6.3,2.48-12.81,4.38-19.35,6.12-3.47,.92-6.08,4.7-4.99,8.33,1.06,3.53,4.64,6.07,8.36,5.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M421,15.7c-1.42-2.54-2.84-5.08-4.26-7.62-.5-.9-.67-2.47,.35-2.51,.32-.01,.62,.18,.88,.38,2.07,1.59,3.29,4.02,4.44,6.36,.35,.72,.72,1.5,.6,2.3-.12,.79-.97,1.51-1.71,1.17"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M361.37,126.82l-.02-.41c1.07-13.88,4.93-27.31,11.76-37.96h0s-13.28,.39-21.23,10.89h0c-7.56,9.06,9.49,27.49,9.49,27.49Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M532.95,145.59l8.12,19.47c1.01,2.41,4.54,2.04,5.01-.53l3.83-20.74c2.75-14.91,3.34-30.14,1.73-45.21l-.77-7.18-29.91,3.19,.77,7.18c1.61,15.08,5.39,29.84,11.22,43.83Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-18",
    cx: 536.6,
    cy: 96.75,
    rx: 18.15,
    ry: 6.84,
    transform: "translate(-7.23 57.43) rotate(-6.09)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 517.5,
    y: 78.66,
    width: 36.25,
    height: 18.15,
    transform: "translate(1077.53 118.18) rotate(173.91)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-10",
    cx: 534.68,
    cy: 78.7,
    rx: 18.15,
    ry: 6.84,
    transform: "translate(-5.33 57.13) rotate(-6.09)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M552.72,76.78c.4,3.76-7.35,7.67-17.32,8.73-9.97,1.06-18.37-1.12-18.77-4.88-1.06-9.97,6.15-18.9,16.12-19.97,9.97-1.06,18.9,6.15,19.97,16.12Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M381.35,175.88c.71,6.67-22.3,14.58-51.4,17.69-29.1,3.1-53.26,.21-53.97-6.45-1.88-17.67,20.18-34.51,49.27-37.61,29.1-3.1,54.21,8.71,56.09,26.38Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M459.4,123.46c.23,2.17-4.25,4.43-10.01,5.04s-10.61-.65-10.84-2.82c-.61-5.76,3.56-10.92,9.31-11.54,5.76-.61,10.92,3.56,11.54,9.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M453.71,123.59c.1,.95-1.86,1.94-4.38,2.21s-4.65-.28-4.75-1.23c-.27-2.52,1.56-4.78,4.08-5.05s4.78,1.56,5.05,4.08Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M433.29,212.25c.38,3.54-6.93,7.22-16.32,8.23-9.39,1-17.31-1.06-17.68-4.6-1-9.39,5.8-17.81,15.19-18.81s17.81,5.8,18.81,15.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M427.18,210.87c.24,2.24-4.38,4.56-10.31,5.2s-10.93-.67-11.17-2.91c-.63-5.93,3.66-11.25,9.59-11.88s11.25,3.66,11.89,9.59Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M226.5,201.35c.38,3.54-6.93,7.22-16.32,8.23-9.39,1-17.31-1.06-17.68-4.6-1-9.39,5.8-17.81,15.19-18.81s17.81,5.8,18.81,15.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M220.85,199.73c.25,2.34-4.57,4.77-10.77,5.43-6.2,.66-11.42-.7-11.67-3.04-.66-6.2,3.83-11.76,10.02-12.42,6.2-.66,11.76,3.83,12.42,10.02Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M426.65,135.18c3.51,32.93-37.38,64.28-91.34,70.03-53.96,5.75-100.54-16.28-104.05-49.2"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 533.96,
    cy: 78.67,
    rx: 74.64,
    ry: 20.99,
    transform: "translate(-5.33 57.05) rotate(-6.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M492.3,69.15c-17.17,5.01-27.91,11.14-27.32,16.68s11.37,8.93,27.92,10.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M503.42,71.29c-17.68,2.7-33.26,9.98-33.38,14.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M574.75,87.65c17.17-5.01,27.91-11.14,27.32-16.68-.56-5.29-11.37-8.93-27.92-10.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M563.64,85.5c17.68-2.7,33.26-9.98,33.38-14.39"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 487.6,
    cy: 220.15,
    rx: 88.35,
    ry: 24.85,
    transform: "translate(-20.59 52.93) rotate(-6.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M438.29,208.87c-20.32,5.94-33.04,13.19-32.34,19.74,.67,6.27,13.46,10.57,33.05,12.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M451.45,211.41c-20.93,3.2-39.38,11.81-39.52,17.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M535.89,230.77c20.32-5.94,33.04-13.19,32.34-19.74-.67-6.27-13.46-10.57-33.05-12.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M522.73,228.23c20.93-3.2,39.38-11.81,39.52-17.03"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 88.26,
    cy: 205.84,
    rx: 88.35,
    ry: 24.85,
    transform: "translate(-21.32 10.52) rotate(-6.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M38.95,194.57c-20.32,5.94-33.04,13.19-32.34,19.74,.67,6.27,13.46,10.57,33.05,12.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M52.11,197.11c-20.93,3.2-39.38,11.81-39.52,17.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M136.55,216.47c20.32-5.94,33.04-13.19,32.34-19.74-.67-6.27-13.46-10.57-33.05-12.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M123.39,213.92c20.93-3.2,39.38-11.81,39.52-17.03"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M374.37,265.64h0c1.75,2.16,4.42,3.38,7.2,3.3l30.43-.87c1.18-.03,1.37-1.72,.22-2l-17.46-4.39c-4.04-1.02-5.92-5.67-3.73-9.21l1.04-1.67h0c-7.12-6.62-18.73-2.15-19.58,7.53l-.08,.89c-.2,2.31,.5,4.61,1.96,6.42Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 247.82,
    y: 139.32,
    width: 4.53,
    height: 18.42,
    transform: "translate(539.36 178.89) rotate(155.28)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-19",
    cx: 246.17,
    cy: 140.03,
    r: 5.59
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M271.31,169.68c.4,3.75-6.11,7.52-14.55,8.42-8.44,.9-15.6-1.41-16-5.16-1.06-9.94,4.92-18.73,13.35-19.63,8.44-.9,16.13,6.43,17.19,16.38Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElizaShipHappy);
export default __webpack_public_path__ + "static/media/eliza-ship-happy.497a59bb38981595e2ccf21ea5410e68.svg";
export { ForwardRef as ReactComponent };